// extracted by mini-css-extract-plugin
export default {"td":"TableBody_td__v2Zle","first-col":"TableBody_first-col__TeO27","row":"TableBody_row__OKPI4"};